module.exports = {"542421100":"那曲镇","542421101":"罗玛镇","542421102":"古露镇","542421200":"香茂乡","542421201":"油恰乡","542421202":"那么切乡","542421203":"孔玛乡","542421204":"达萨乡","542421205":"劳麦乡","542421206":"色雄乡","542421207":"尼玛乡","542421208":"达前乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542421.json
// module id = 2894
// module chunks = 0